import { DataLineageNodeTypes } from '@y42/json-schema';
import { Group, Part, Point } from 'gojs';
import { DataLineageUINode } from '../data-lineage-diagram.model';

export const shiftNodes = (group: Group) => {
  const diagram = group.diagram;
  if (diagram === null) {
    return;
  }
  group.ensureBounds();
  const actualBounds = group.actualBounds;

  const moveableParts: Part[] = [];

  diagram.findTopLevelGroups().each((node) => {
    const ab = node.actualBounds;
    if (ab.y > actualBounds.y) {
      moveableParts.push(node);
    }
  });

  diagram.nodes.each((node) => {
    const nodeData = node.data as DataLineageUINode;
    const ab = node.actualBounds;
    if (nodeData.category === DataLineageNodeTypes.Widget && ab.y > actualBounds.y) {
      moveableParts.push(node);
    }
  });

  const offset = group.memberParts.count * 70;

  if (group.isSubGraphExpanded) {
    diagram.moveParts(moveableParts, new Point(0, offset));
  } else {
    diagram.moveParts(moveableParts, new Point(0, -offset));
  }
};
